function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

export function startPulse({
  endpoint = '/api/admin/pulse',
  baseInterval = 15000,
  jitter = 3000,
  page = () => window.location.pathname
} = {}) {
  let timer = null;

  const isActive = () =>
    document.visibilityState === 'visible' && navigator.onLine;

  const csrf =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
    getCookie('XSRF-TOKEN');

  const sendViaFetch = (payload) => {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrf || '',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: payload,
      keepalive: true,
      credentials: 'same-origin'
    }).catch(() => {});
  };

  const send = () => {
    const payload = JSON.stringify({ ts: Date.now(), page: page() });
    if (csrf) {
      sendViaFetch(payload);
    } else if ('sendBeacon' in navigator) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(endpoint, blob);
    } else {
      sendViaFetch(payload);
    }
  };

  const schedule = () => {
    clearTimeout(timer);
    if (!isActive()) return;
    const delay = baseInterval + Math.floor(Math.random() * jitter);
    timer = setTimeout(() => {
      if (isActive()) send();
      schedule();
    }, delay);
  };

  const onVis     = () => { clearTimeout(timer); if (isActive()) schedule(); };
  const onOnline  = () => { clearTimeout(timer); if (isActive()) schedule(); };
  const onOffline = () => { clearTimeout(timer); };
  const onPageHide = () => { send(); };

  document.addEventListener('visibilitychange', onVis, { passive: true });
  window.addEventListener('online',  onOnline,  { passive: true });
  window.addEventListener('offline', onOffline, { passive: true });
  window.addEventListener('pagehide', onPageHide);

  schedule();

  // ❗ Сделали stop отдельной функцией, чтобы вернуть и stop, и ping.
  const stop = () => {
    clearTimeout(timer);
    document.removeEventListener('visibilitychange', onVis);
    window.removeEventListener('online',  onOnline);
    window.removeEventListener('offline', onOffline);
    window.removeEventListener('pagehide', onPageHide);
  };

  // ❗ Новое: публичный "одиночный" пинг с проверкой активности вкладки.
  const ping = () => { if (isActive()) send(); };

  return { stop, ping };
}